export const DRAWER_PAGE = {
  CONTACT_FORM: 'contact-form',
  PRESCREEN_FORM: 'prescreen-form',
}

export const DEFAULT_MESSAGE_TEMPLATE = `Hi {agent_name}, 
I’m interested in {rental_property_address}. Could you please contact me?`

export const MESSAGE_TYPE = {
  PRE_SCREEN: 'pre-screen',
  MESSAGE: 'msg',
}
